export default "__VITE_ASSET__cf8772d9__"